import Rollbar from 'rollbar';
import { serverConfig } from 'config';
import { transformError } from 'components/RollbarSDK/transform-error';

export default class RollbarGlobal {
  static rollbar = RollbarGlobal.init();

  static init() {
    const rollbar = new Rollbar({
      accessToken: serverConfig.rollbar.backendToken,
      environment: serverConfig.envWithCluster,
    });

    rollbar.configure({
      transform: transformError,
    });

    return rollbar;
  }
}
